document.addEventListener('DOMContentLoaded', function () {

  const buttons = document.querySelectorAll('.mobile-bottom-link');
  const panels = document.querySelectorAll('.bottom-panel');

  buttons.forEach(function (button) {

    button.addEventListener('click', function (e) {

      e.preventDefault();
      e.stopPropagation();

      const panelName = button.dataset.panel;

      const targetPanel = document.querySelector(
        '.' + panelName + '-bottom-panel'
      );

      if (!targetPanel) return;

      panels.forEach(function (panel) {

        if (panel === targetPanel) {
          panel.classList.toggle('is-open');
        } else {
          panel.classList.remove('is-open');
        }

      });

    });

  });

  // 外側クリックで閉じる
  document.addEventListener('click', function (e) {

    if (
      !e.target.closest('.mobile-bottom-nav') &&
      !e.target.closest('.bottom-panel')
    ) {

      panels.forEach(function (panel) {
        panel.classList.remove('is-open');
      });

    }

  });

});